import { Routes } from '@angular/router';
import { TechgeekContainerComponent } from './techgeek-container/techgeek-container.component';
import { TechgeekCoverComponent } from './techgeek-cover/techgeek-cover.component';
import { Techgeek1Component } from './techgeek-1/techgeek-1.component';
import { Techgeek2Component } from './techgeek-2/techgeek-2.component';
import { Techgeek3Component } from './techgeek-3/techgeek-3.component';
import { Techgeek4Component } from './techgeek-4/techgeek-4.component';
import { Techgeek5Component } from './techgeek-5/techgeek-5.component';
import { Techgeek6Component } from './techgeek-6/techgeek-6.component';

export const techgeek_routes:Routes=[
    {path:"",component:TechgeekContainerComponent,children:[
        {path:'techgeek',component:TechgeekCoverComponent},
        {path:'techgeek-1',component:Techgeek1Component},
        {path:'techgeek-2',component:Techgeek2Component},
        {path:'techgeek-3',component:Techgeek3Component},
        {path:'techgeek-4',component:Techgeek4Component},
        {path:'techgeek-5',component:Techgeek5Component},
        {path:'techgeek-6',component:Techgeek6Component},
    ]}
]